import $ from "jquery";

function EditNewsList() {
  $(".js-news-edit").on("click", function () {
    var button = $(this),
      page = button.closest(".js-news"),
      link = page.find(".js-news-link");

    if (page.hasClass("is-editing")) {
      page.removeClass("is-editing");
      button.text("既読の管理");
      $(link).attr("tabindex", "0");
    } else {
      page.addClass("is-editing");
      button.text("キャンセル");
      // フォーカスを禁止
      $(link).attr("tabindex", "-1");
    }
  });
}

export { EditNewsList };
